/* Hero.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"],
  _excluded7 = ["as", "style"],
  _excluded8 = ["as", "style"],
  _excluded9 = ["as", "style"],
  _excluded10 = ["as", "style"],
  _excluded11 = ["as", "style"],
  _excluded12 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _27 = "._otyr1eps{margin-bottom:var(--ds-space-100)}";
const _26 = "._94n51df4{bottom:-.3rem}";
const _25 = "._1xi2idpf{right:0}";
const _24 = "._1ltvidpf{left:0}";
const _23 = "._154iidpf{top:0}";
const _22 = "._kqswstnw{position:absolute}";
const _21 = "._4t3i1wug{height:auto}";
const _20 = "@media (min-width:48rem){._6o24cs5v{order:2}._14b51ssb{width:50%}}";
const _19 = "._1f49kb7n{order:1}";
const _18 = "@media (min-width:48rem) and (max-width:63.99rem){._lg5rhiv4{margin-top:var(--ds-space-400)}}";
const _17 = "._19pkl6l0{margin-top:var(--ds-space-300)}";
const _16 = "@media (min-width:48rem){._6o24kb7n{order:1}._14b51ssb{width:50%}}";
const _15 = "._1f49cs5v{order:2}";
const _14 = "._135a1h6o{justifycontent:center}";
const _13 = "@media (min-width:48rem){._1xlo1osq{height:100%}._1lp7vrvc{flex-direction:row}._19wgxy5q{gap:var(--ds-space-400,2pc)}}";
const _12 = "._zulp1ejb{gap:var(--ds-space-300,24px)}";
const _11 = "._2lx21bp4{flex-direction:column}";
const _10 = "._4cvr1h6o{align-items:center}";
const _9 = "._1e0c1txw{display:flex}";
const _8 = "._syaz3etr{color:var(--ds-text-inverse)}";
const _7 = "._otyrxjmg{margin-bottom:var(--ds-space-200)}";
const _6 = "._19pkidpf{margin-top:0}";
import { Hide, media } from '@atlaskit/primitives/responsive';
import { BodyLarge, Breadcrumbs, BreadcrumbsItem, FluidContainer, H1, useMediumScreen } from '@atlassian/mpac-primitives';
import { SearchEmbedded } from '@atlassian/mpac-search';
import { useHistory } from '@atlassian/mpac-ui';
import React, { useMemo } from 'react';
import HeroImage from '../../assets/hero.svg';
import HeroTopLeftVisual from '../../assets/hero-left-top-visual.svg';
import HeroBottomRightVisual from '../../assets/hero-right-bottom-visual.svg';
const _5 = "@media (min-width:30rem){._1wbf1jq7{padding:var(--ds-space-500) 0 var(--ds-space-800) 0}}";
const _4 = "._11q7xhyp{background:var(--ds-text-accent-blue-bolder)}";
const _3 = "._1yt4dty4{padding:var(--ds-space-400) 0 var(--ds-space-500) 0}";
const _2 = "._1bsb1osq{width:100%}";
const _ = "._kqswh2mm{position:relative}";
const HeroWrapper = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_kqswh2mm _1bsb1osq _1yt4dty4 _11q7xhyp _1wbf1jq7", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  HeroWrapper.displayName = 'HeroWrapper';
}
const Heading = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = H1,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_6, _7, _8]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pkidpf _otyrxjmg _syaz3etr", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Heading.displayName = 'Heading';
}
const Description = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = BodyLarge,
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_8, _6]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_syaz3etr _19pkidpf", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Description.displayName = 'Description';
}
const Search = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = SearchEmbedded,
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_2]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bsb1osq", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Search.displayName = 'Search';
}
const HeroInner = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_9, _10, _11, _12, _13]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _4cvr1h6o _2lx21bp4 _zulp1ejb _1xlo1osq _1lp7vrvc _19wgxy5q", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  HeroInner.displayName = 'HeroInner';
}
const ContentSearchContainer = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_9, _2, _11, _14, _15, _16]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _1bsb1osq _2lx21bp4 _135a1h6o _1f49cs5v _6o24kb7n _14b51ssb", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ContentSearchContainer.displayName = 'ContentSearchContainer';
}
const SearchWrapper = forwardRef((_ref7, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref7,
    __cmplp = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_2, _17, _18]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bsb1osq _19pkl6l0 _lg5rhiv4", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SearchWrapper.displayName = 'SearchWrapper';
}
const ImageContainer = forwardRef((_ref8, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref8,
    __cmplp = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_2, _19, _20]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bsb1osq _1f49kb7n _6o24cs5v _14b51ssb", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ImageContainer.displayName = 'ImageContainer';
}
const Image = forwardRef((_ref9, __cmplr) => {
  let {
      as: C = "img",
      style: __cmpls
    } = _ref9,
    __cmplp = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_2, _21]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bsb1osq _4t3i1wug", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Image.displayName = 'Image';
}
const HeroTopLeftImage = forwardRef((_ref10, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref10,
    __cmplp = _objectWithoutProperties(_ref10, _excluded10);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_22, _23, _24]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_kqswstnw _154iidpf _1ltvidpf", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  HeroTopLeftImage.displayName = 'HeroTopLeftImage';
}
const HeroBottomRightImage = forwardRef((_ref11, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref11,
    __cmplp = _objectWithoutProperties(_ref11, _excluded11);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_22, _25, _26]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_kqswstnw _1xi2idpf _94n51df4", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  HeroBottomRightImage.displayName = 'HeroBottomRightImage';
}
const BreadcrumbContainer = forwardRef((_ref12, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref12,
    __cmplp = _objectWithoutProperties(_ref12, _excluded12);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_27]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_otyr1eps", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  BreadcrumbContainer.displayName = 'BreadcrumbContainer';
}
export const Hero = _ref13 => {
  let {
    heading,
    description,
    breadcrumbTitle,
    productIdForAlgolia,
    productName
  } = _ref13;
  const history = useHistory();
  const showBelowMedium = useMediumScreen();
  const handleBreadcrumbsClick = event => {
    event.preventDefault();
    history === null || history === void 0 ? void 0 : history.push('/');
  };
  const searchPlaceholder = productName ? {
    mobile: "Search ".concat(productName, " for apps"),
    desktop: "Search ".concat(productName, " for apps within Marketplace")
  } : undefined;
  const additionalQueryParams = useMemo(() => {
    return productIdForAlgolia ? {
      product: productIdForAlgolia
    } : undefined;
  }, [productIdForAlgolia]);
  return /*#__PURE__*/React.createElement(HeroWrapper, null, /*#__PURE__*/React.createElement(Hide, {
    below: "lg"
  }, /*#__PURE__*/React.createElement(HeroTopLeftImage, null, /*#__PURE__*/React.createElement(Image, {
    alt: "",
    src: HeroTopLeftVisual
  }))), /*#__PURE__*/React.createElement(FluidContainer, null, breadcrumbTitle && /*#__PURE__*/React.createElement(BreadcrumbContainer, null, /*#__PURE__*/React.createElement(Breadcrumbs, {
    textColor: "var(--ds-text-inverse)"
  }, /*#__PURE__*/React.createElement(BreadcrumbsItem, {
    href: "/",
    text: "Marketplace",
    onClick: handleBreadcrumbsClick
  }), /*#__PURE__*/React.createElement(BreadcrumbsItem, {
    text: breadcrumbTitle,
    onClick: event => event.preventDefault()
  }))), /*#__PURE__*/React.createElement(HeroInner, null, /*#__PURE__*/React.createElement(ContentSearchContainer, null, /*#__PURE__*/React.createElement(Heading, null, heading), /*#__PURE__*/React.createElement(Description, null, description), !showBelowMedium && /*#__PURE__*/React.createElement(SearchWrapper, null, /*#__PURE__*/React.createElement(Search, {
    additionalQueryParams: additionalQueryParams,
    searchPlaceholder: searchPlaceholder
  }))), /*#__PURE__*/React.createElement(ImageContainer, null, /*#__PURE__*/React.createElement(Image, {
    alt: "",
    src: HeroImage,
    width: 752,
    height: 398
  }))), showBelowMedium && /*#__PURE__*/React.createElement(SearchWrapper, null, /*#__PURE__*/React.createElement(Search, {
    additionalQueryParams: additionalQueryParams,
    searchPlaceholder: searchPlaceholder
  }))), /*#__PURE__*/React.createElement(Hide, {
    below: "lg"
  }, /*#__PURE__*/React.createElement(HeroBottomRightImage, null, /*#__PURE__*/React.createElement(Image, {
    alt: "",
    src: HeroBottomRightVisual
  }))));
};